import moment from 'jalali-moment';
import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CalculatorService } from '../../services/calculator.service';
import { UiFormFieldBuilderModule } from '@digipay/ui-form-field-builder';
import { AvailableFundsComponent } from '../../components/available-funds/available-funds.component';
import { takeUntil } from 'rxjs';
import { BaseComponent } from '../../../../components/core/components/base/base.component';
import { CalculatorEfficiencies } from '../../../../data-access/models/calculator-efficiencies.model';
import { CALCULATOR_PROFIT_ROUTE, HOME_ROUTE } from '../../../../data-access/constants/app-routes';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { SpinnerComponent } from '../../../../shared/components/spinner/spinner.component';

@Component({
  selector: 'app-calculator',
  templateUrl: './calculator.component.html',
  styleUrls: ['./calculator.component.scss'],
  standalone: true,
  imports: [
    NgxAppBarComponent,
    ReactiveFormsModule,
    AvailableFundsComponent,
    UiFormFieldBuilderModule,
    NgxButtonComponent,
    SpinnerComponent,
  ],
})
export class CalculatorComponent extends BaseComponent implements OnInit {
  form: FormGroup;
  isLoading = false;
  funds: CalculatorEfficiencies[] = [];
  fromDateRange!: [number, number];
  toDateRange!: [number, number];
  navigationService = inject(WealthNavigationService);
  private route = inject(ActivatedRoute);
  private formBuilder = inject(FormBuilder);
  private calcService = inject(CalculatorService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      fromDate: ['', Validators.required],
      toDate: ['', Validators.required],
      amount: ['', Validators.required],
    });
    this.setDateRangeValues();
    const params = this.route.snapshot.queryParams;
    const fromDate = moment(+params['from']).locale('en').format('YYYY-MM-DD');
    const toDate = moment(+params['to']).locale('en').format('YYYY-MM-DD');

    if (Object.keys(params).length)
      this.calcService
        .getFunds({
          fromDate,
          toDate,
          amount: params['amount'],
        })
        .pipe(takeUntil(this.destroyObservable))
        .subscribe((res: CalculatorEfficiencies[]) => {
          this.funds = res;
        });
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }

  onCalculate() {
    const from = this.form.value.fromDate;
    const to = this.form.value.toDate;

    this.isLoading = true;
    this.navigationService.navigateWithQueryParams([CALCULATOR_PROFIT_ROUTE], {
      queryParams: { from, to, amount: this.form.value.amount },
    });
  }

  setDateRangeValues() {
    const beggingDay = new Date(moment('2008-03-21').format()).getTime();
    const twoDaysAgo = new Date();
    twoDaysAgo.setDate(twoDaysAgo.getDate() - 2);
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);

    this.fromDateRange = [beggingDay, twoDaysAgo.getTime()];
    this.toDateRange = [beggingDay, yesterday.getTime()];
  }

  fromDateChanged(value: number) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const selectedDate = new Date(value);
    selectedDate.setDate(selectedDate.getDate() + 1);

    this.toDateRange = [selectedDate.getTime(), yesterday.getTime()];
  }

  toDateChanged(value: number) {
    const selectedDate = new Date(value);
    selectedDate.setDate(selectedDate.getDate() - 1);
    this.fromDateRange[1] = selectedDate.getTime();
  }
}
